import React, { useEffect, useState } from "react";
import { QuickSearchOneBook } from "../Services/Books.service";
import { Docs } from "../Types/SearchResult.interface";
import { useParams } from "react-router";
import { searchWikidata } from "../Services/Wikidata.service";
import "../Styles/Work.css";
import { WikidataEntity } from "../Types/WikidataEntity.interface";
import { Link } from "react-router-dom";
import NotFoundPage from "./NotFoundPage";

const WorkPage = () => {
    const [book, setBook] = useState<Docs | null>(null);
    const [wikidata, setWikidata] = useState<WikidataEntity | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const { id } = useParams<{ id: string }>();

    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            try {
                const bookData = await QuickSearchOneBook(id || "");
                setBook(bookData);

                if (bookData && bookData.id_wikidata) {
                    const wikidataInfo = await searchWikidata(bookData.id_wikidata[0]);
                    setWikidata(wikidataInfo);
                }
                setLoading(false);
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoading(false);
            }
        };

        const timeout = setTimeout(() => {
            if (isMounted) {
                setLoading(false);
            }
        }, 30000); // 30 secondes

        fetchData();

        return () => {
            isMounted = false;
            clearTimeout(timeout);
        };
    }, [id]);

    return (
        <div className="work-page">
            {loading ? (
                <span className="loader"></span>
            ) : (
                book ? (
                    <div className={"work-content"}>
                        <div className="book-details">
                            <img
                                src={`https://covers.openlibrary.org/b/id/${book.cover_i}-L.jpg`}
                                alt={book.title || "Book cover"}
                                className="book-image"
                            />
                            <div className="book-info">
                                <h1 className="book-title">{book.title}</h1>
                                <p className="book-author">{book.author_name && `Par ${book.author_name.join(", ")}`}</p>
                                {wikidata && wikidata.descriptions && (
                                    <p className="book-description">
                                        {wikidata.descriptions.fr ? wikidata.descriptions.fr.value : (wikidata.descriptions.en ? wikidata.descriptions.en.value : "Description not available")}
                                    </p>
                                )}
                                <p className="book-publish-date">Publish
                                    Date: {book.publish_date && book.publish_date[0]}</p>
                            </div>
                        </div>
                        <h2 className="theme-title">Thèmes</h2>
                        <p className="book-subject">
                            {book.subject && Array.isArray(book.subject) && book.subject.map((subject: string, index: number) => (
                                <React.Fragment key={index}>
                                    {subject}
                                    {index !== (book.subject!.length - 1) && <br/>}
                                </React.Fragment>
                            ))}
                        </p>
                        {wikidata && (
                            <div className="wikidata-info">
                                <h2 className="wiki-title">Informations Wikidata</h2>
                                <ul>
                                    <li><strong>Page ID:</strong> {wikidata.pageid}</li>
                                    <li><strong>Namespace:</strong> {wikidata.ns}</li>
                                    <li><strong>Title:</strong> {wikidata.title}</li>
                                    <li><strong>Last Revision ID:</strong> {wikidata.lastrevid}</li>
                                    <li><strong>Modified:</strong> {wikidata.modified}</li>
                                    <li><strong>Type:</strong> {wikidata.type}</li>
                                    <li><strong>ID:</strong> {wikidata.id}</li>
                                    <br/>
                                    <Link to={`https://fr.wikipedia.org/wiki/${book.title}` } target="_blank">Consulter la page wikipedia</Link>
                                </ul>
                            </div>
                        )}
                    </div>
                ) : (
                    <div>
                        <h2 className={"page-title"}>Le livre recherché n'a pas pu être trouvé...</h2>
                    </div>
                )
            )}
        </div>
    );
};

export default WorkPage;